// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + (chunkId === 777 ? "recorder" : chunkId) + "." + {"378":"9afbb72c","777":"9a46e746","799":"fb7cdafc"}[chunkId] + ".chunk.js");